import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.js";

function TaskForm({
  initialData,
  onSubmit,
  submitLabel = "Opslaan",
  isEditing = false,
}) {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("jwtToken");
  const { userInfo } = useAuth();
  const { role, is_single_user, user_location_ids } = userInfo;

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "active",
    user_ids: [],
    location_id: "", // ✅ toegevoegd
  });

  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);

  // Initial data (bij edit)
  useEffect(() => {
    if (initialData) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
        user_ids: initialData.user_ids || [],
        location_id: initialData.location_id || "",
      }));
    }
  }, [initialData]);

  // Users ophalen
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/user/getallnameofusers`,
          {
            headers: {
              Authorization: `Bearer ${token}`            },
          }
        );
        setUsers(response.data.data || []);
      } catch (err) {
        console.error("Fout bij ophalen users", err);
      }
    };
    fetchUsers();
  }, [token]);

  // Locaties ophalen (alleen voor super_admin)
  useEffect(() => {
    if (role === "super_admin") {
      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/location/allLocations`, {
          headers: {
            Authorization: `Bearer ${token}`          },
        })
        .then((res) => {
          const locs = res.data.data || res.data;
          setLocations(Array.isArray(locs) ? locs : []);
        })
        .catch((err) => console.error("Error fetching locations", err));
    }
  }, [role, token]);

  // Handlers
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUserSelect = (selectedOptions) => {
    const ids = selectedOptions.map((option) => option.value);
    setFormData({ ...formData, user_ids: ids });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };

    // Als geen super_admin → automatisch eigen locatie koppelen
    if (role !== "super_admin") {
      payload.location_id = user_location_ids?.[0] || null;
    }

    onSubmit(payload);
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Titel */}
      <div className="mb-3">
        <label className="form-label">Titel</label>
        <input
          type="text"
          name="name"
          className="form-control rounded-0"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      {/* Beschrijving */}
      <div className="mb-3">
        <label className="form-label">Beschrijving</label>
        <textarea
          name="description"
          className="form-control rounded-0"
          rows="4"
          value={formData.description}
          onChange={handleChange}
        />
      </div>

      {/* Status */}
      <div className="mb-3">
        <label className="form-label">Status</label>
        <select
          name="status"
          className="form-select rounded-0"
          value={formData.status}
          onChange={handleChange}
        >
          <option value="active">Actief</option>
          <option value="inactive">Inactief</option>
        </select>
      </div>

      {/* Locatie (alleen super_admin + niet single user) */}
      {!is_single_user && role === "super_admin" && (
        <div className="mb-3">
          <label className="form-label">Locatie</label>
          <select
            className="form-select rounded-0"
            value={formData.location_id || ""}
            onChange={(e) =>
              setFormData({ ...formData, location_id: e.target.value })
            }
          >
            <option value="">-- Kies locatie --</option>
            {locations.map((loc) => (
              <option key={loc.location_id} value={loc.location_id}>
                {loc.location_name}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Users */}
      <div className="mb-3">
        <label className="form-label fw-bold">Koppel aan user(s)</label>
        <Select
          isMulti
          options={users.map((user) => ({
            value: user.user_id,
            label: `${user.name} (${user.role})`,
          }))}
          value={users
            .filter((user) => formData.user_ids.includes(user.user_id))
            .map((user) => ({
              value: user.user_id,
              label: `${user.name} (${user.role})`,
            }))}
          onChange={handleUserSelect}
          placeholder="Zoek en selecteer users..."
          className="basic-multi-select"
          classNamePrefix="select"
        />
      </div>

      {/* Knoppen */}
      <div className="d-flex gap-2 mt-3">
        <button type="submit" className="btn btn-success rounded-0">
          {submitLabel}
        </button>
        <button
          type="button"
          className="btn btn-secondary rounded-0"
          onClick={() => navigate(-1)}
        >
          Annuleren
        </button>
      </div>
    </form>
  );
}

export default TaskForm;
